document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.image-carousel').forEach((el) => {
    const wrapper = el.closest('.slider-wrapper');
    const slidesPerView = parseFloat(el.dataset.slidesPerView) || 1;
    const effect = el.dataset.transition || 'slide';
    const spaceBetween = parseInt(el.dataset.space) || 0;
    const autoplay = el.dataset.autoplay === '1';
    const arrows = el.dataset.arrows === '1';
    const pagination = el.dataset.pagination === '1';
    const centerMode = el.dataset.center === '1';
    const loop = el.dataset.loop ==='1';

    new Swiper(el, {
      slidesPerView,
      effect,
      spaceBetween,
      loop,
      centeredSlides: centerMode,
      autoplay: autoplay ? { delay: 3000 } : false,
      pagination: pagination ? {
        el: wrapper.querySelector('.swiper-pagination'),
        clickable: true,
      } : false,
      navigation: arrows ? {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev'),
      } : false,
    });
  });
});